<template>
  <div
    class="flex flex-col items-center justify-center cursor-pointer p-2"
    :class="StateBackground + ' ' + size"
  >
    <svg xmlns="http://www.w3.org/2000/svg" class="fill-current" viewBox="0 0 20.437 19.211" width="21">
      <path d="M12.719,5.4C7.082,5.4,2.5,9.122,2.5,13.726a.391.391,0,0,0,.129.3L12.4,24.461a.5.5,0,0,0,.323.151.416.416,0,0,0,.323-.151l9.767-10.412a.425.425,0,0,0,.129-.3C22.937,9.122,18.355,5.4,12.719,5.4Zm0,7.185a3.368,3.368,0,0,1,2.668.9.482.482,0,0,1,.022.387l-2.689,8.67L10.03,13.855a.474.474,0,0,1,0-.344A3.241,3.241,0,0,1,12.719,12.585Zm-6.475,0c1.7,0,2.646.645,2.775,1.14l2.711,8.713L3.511,13.661C3.6,13.188,4.63,12.585,6.243,12.585ZM16.4,13.726c.172-.559,1.076-1.14,2.8-1.14,1.613,0,2.625.6,2.732,1.076l-8.218,8.777Z" transform="translate(-2.5 -5.4)"/>
    </svg>
  </div>
</template>

<script>
import { parachuteStateColor } from "@/utils/Utils.js";

export default {
  props: {
    config: Object,
    size: String,
  },
  computed: {
    StateBackground() {
      var mode_code = this.config?.parachute?.status?.fts_state != null
          ? this.config.parachute.status.fts_state
          : -1;

      let LastPing =
        this.config?.parachute?.status?.LastPing != null
          ? parseInt(this.config.parachute?.status.LastPing)
          : 99999999999;

      return "bg-" + parachuteStateColor(mode_code, LastPing);
    },
  },
  methods: {
  },
};
</script>
